import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationRentalProperties: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3749_10271"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3749_10271)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <path
          stroke={colors.primary[400]}
          strokeDasharray="8 8"
          strokeLinecap="round"
          strokeWidth="4"
          d="M178 66h-72.5c-11.046 0-20 8.954-20 20v88"
        ></path>
        <path
          stroke={colors.primary[400]}
          strokeDasharray="8 8"
          strokeLinecap="round"
          strokeWidth="4"
          d="M175.5 66H248c11.046 0 20 8.954 20 20v88"
        ></path>
        <path
          stroke={colors.primary[400]}
          strokeDasharray="8 8"
          strokeLinecap="round"
          strokeWidth="4"
          d="M178 66v0c.275 0 .498.225.495.5L177.5 174"
        ></path>
        <path
          fill={colors.primary[150]}
          fillRule="evenodd"
          d="M90.655 159.744l27.047 27.314c.831.849 1.298 2 1.298 3.201a4.577 4.577 0 01-1.298 3.201 4.38 4.38 0 01-3.133 1.327 4.381 4.381 0 01-3.134-1.327l-1.283-1.31V223H62.878v-30.866l23.63-24.14-.007-.008-24.936 25.474a4.381 4.381 0 01-3.133 1.327 4.381 4.381 0 01-3.134-1.327A4.576 4.576 0 0154 190.259c0-1.201.467-2.352 1.298-3.201l27.047-27.314A5.848 5.848 0 0186.5 158c1.556 0 3.049.627 4.155 1.744zm19.495 5.824c0-.657-.256-1.286-.71-1.751a2.402 2.402 0 00-1.714-.725h-4.007a2.4 2.4 0 00-1.714.725 2.507 2.507 0 00-.71 1.751v4.899l8.863 8.949-.008-13.848z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[150]}
          d="M117.702 187.058l1.429-1.399-.008-.009-1.421 1.408zm-27.047-27.314l-1.421 1.407 1.42-1.407zm20.78 33.716l1.429-1.399-1.429 1.399zm-1.283-1.31l1.429-1.399a1.999 1.999 0 00-3.429 1.399h2zm0 30.85v2a2 2 0 002-2h-2zm-47.274 0h-2a2 2 0 002 2v-2zm0-30.866l-1.43-1.399c-.365.373-.57.876-.57 1.399h2zm23.63-24.14l1.43 1.399a2.001 2.001 0 000-2.799l-1.43 1.4zm-.007-.008l1.43-1.399a2.001 2.001 0 00-2.86 0l1.43 1.399zM61.565 193.46l-1.43-1.399 1.43 1.399zm-6.267 0l1.43-1.399-1.43 1.399zm0-6.402l-1.421-1.408-.008.009 1.429 1.399zm27.047-27.314l1.421 1.407-1.42-1.407zm27.805 5.824h-2v.002l2-.002zm-8.145-1.751l1.43 1.399-1.43-1.399zm-.71 6.65h-2c0 .527.209 1.033.58 1.408l1.42-1.408zm8.863 8.949l-1.421 1.408a2 2 0 003.421-1.409l-2 .001zm8.965 6.234l-27.047-27.313-2.842 2.814 27.047 27.314 2.842-2.815zm1.877 4.609a6.572 6.572 0 00-1.869-4.6l-2.858 2.798c.461.47.727 1.118.727 1.802h4zm-1.869 4.6a6.572 6.572 0 001.869-4.6h-4c0 .684-.266 1.332-.727 1.802l2.858 2.798zm-4.562 1.928c1.719 0 3.36-.699 4.562-1.928l-2.858-2.798c-.46.47-1.074.726-1.704.726v4zm-4.563-1.928a6.383 6.383 0 004.563 1.928v-4a2.385 2.385 0 01-1.705-.726l-2.858 2.798zm-1.283-1.31l1.283 1.31 2.858-2.798-1.283-1.31-2.858 2.798zm-.571-1.399V223h4v-30.85h-4zm2 28.85H86.515v4h23.637v-4zm-23.637 0H62.878v4h23.637v-4zm-21.637 2v-30.866h-4V223h4zm-.57-29.467l23.63-24.14-2.859-2.798-23.63 24.14 2.858 2.798zm20.764-24.148l.007.008 2.858-2.799-.007-.007-2.858 2.798zm-22.078 25.474l24.936-25.474-2.858-2.798-24.936 25.474 2.858 2.798zm-4.563 1.928c1.72 0 3.36-.699 4.563-1.928l-2.858-2.798c-.46.47-1.074.726-1.705.726v4zm-4.562-1.928a6.384 6.384 0 004.563 1.928v-4c-.631 0-1.245-.256-1.705-.726l-2.858 2.798zm-1.869-4.6c0 1.718.667 3.373 1.869 4.6l2.858-2.798a2.576 2.576 0 01-.727-1.802h-4zm1.869-4.6a6.575 6.575 0 00-1.869 4.6h4c0-.684.266-1.332.727-1.802l-2.858-2.798zm27.055-27.322L53.877 185.65l2.842 2.815 27.047-27.314-2.842-2.814zM86.5 156a7.847 7.847 0 00-5.576 2.337l2.842 2.814A3.849 3.849 0 0186.5 160v-4zm5.576 2.337A7.847 7.847 0 0086.5 156v4c1.015 0 1.998.409 2.734 1.151l2.842-2.814zm15.934 6.879c.085.086.14.212.14.352h4a4.505 4.505 0 00-1.281-3.15l-2.859 2.798zm-.284-.124c.098 0 .201.039.284.124l2.859-2.798a4.398 4.398 0 00-3.143-1.326v4zm-4.007 0h4.007v-4h-4.007v4zm-.284.124a.396.396 0 01.284-.124v-4a4.398 4.398 0 00-3.143 1.326l2.859 2.798zm-.14.352c0-.14.055-.266.14-.352l-2.859-2.798a4.506 4.506 0 00-1.28 3.15h3.999zm0 4.899v-4.899h-4v4.899h4zm8.284 7.542l-8.863-8.949-2.842 2.815 8.863 8.949 2.842-2.815zm-3.429-12.439l.008 13.848 4-.003-.008-13.848-4 .003z"
        ></path>
        <path
          fill={colors.primary[150]}
          fillRule="evenodd"
          d="M181.655 159.744l27.047 27.314c.831.849 1.298 2 1.298 3.201a4.577 4.577 0 01-1.298 3.201 4.38 4.38 0 01-3.133 1.327 4.381 4.381 0 01-3.134-1.327l-1.283-1.31V223h-47.274v-30.866l23.63-24.14-.007-.008-24.936 25.474a4.381 4.381 0 01-3.134 1.327 4.38 4.38 0 01-3.133-1.327 4.577 4.577 0 01-1.298-3.201c0-1.201.467-2.352 1.298-3.201l27.047-27.314A5.847 5.847 0 01177.5 158c1.556 0 3.049.627 4.155 1.744zm19.495 5.824c0-.657-.256-1.286-.71-1.751a2.402 2.402 0 00-1.714-.725h-4.007a2.4 2.4 0 00-1.714.725 2.507 2.507 0 00-.71 1.751v4.899l8.863 8.949-.008-13.848z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[150]}
          d="M208.702 187.058l1.429-1.399-.008-.009-1.421 1.408zm-27.047-27.314l-1.421 1.407 1.421-1.407zm20.78 33.716l1.429-1.399-1.429 1.399zm-1.283-1.31l1.429-1.399a1.999 1.999 0 00-3.429 1.399h2zm0 30.85v2a2 2 0 002-2h-2zm-47.274 0h-2a2 2 0 002 2v-2zm0-30.866l-1.429-1.399a1.998 1.998 0 00-.571 1.399h2zm23.63-24.14l1.429 1.399a2 2 0 000-2.799l-1.429 1.4zm-.007-.008l1.429-1.399a2 2 0 00-2.858 0l1.429 1.399zm-24.936 25.474l-1.429-1.399 1.429 1.399zm-6.267 0l1.429-1.399-1.429 1.399zm0-6.402l-1.421-1.408-.008.009 1.429 1.399zm27.047-27.314l1.421 1.407-1.421-1.407zm27.805 5.824h-2v.002l2-.002zm-8.145-1.751l1.43 1.399-1.43-1.399zm-.71 6.65h-2c0 .527.208 1.033.579 1.408l1.421-1.408zm8.863 8.949l-1.421 1.408a2 2 0 003.421-1.409l-2 .001zm8.965 6.234l-27.047-27.313-2.842 2.814 27.047 27.314 2.842-2.815zm1.877 4.609a6.572 6.572 0 00-1.869-4.6l-2.858 2.798c.461.47.727 1.118.727 1.802h4zm-1.869 4.6a6.572 6.572 0 001.869-4.6h-4c0 .684-.266 1.332-.727 1.802l2.858 2.798zm-4.562 1.928c1.719 0 3.36-.699 4.562-1.928l-2.858-2.798c-.46.47-1.074.726-1.704.726v4zm-4.563-1.928a6.383 6.383 0 004.563 1.928v-4a2.385 2.385 0 01-1.705-.726l-2.858 2.798zm-1.283-1.31l1.283 1.31 2.858-2.798-1.283-1.31-2.858 2.798zm-.571-1.399V223h4v-30.85h-4zm2 28.85h-23.637v4h23.637v-4zm-23.637 0h-23.637v4h23.637v-4zm-21.637 2v-30.866h-4V223h4zm-.571-29.467l23.63-24.14-2.858-2.798-23.63 24.14 2.858 2.798zm20.765-24.148l.007.008 2.858-2.799-.007-.007-2.858 2.798zm-22.078 25.474l24.936-25.474-2.858-2.798-24.936 25.474 2.858 2.798zm-4.563 1.928c1.72 0 3.361-.699 4.563-1.928l-2.858-2.798c-.46.47-1.074.726-1.705.726v4zm-4.562-1.928a6.382 6.382 0 004.562 1.928v-4c-.63 0-1.244-.256-1.704-.726l-2.858 2.798zm-1.869-4.6c0 1.718.667 3.373 1.869 4.6l2.858-2.798a2.574 2.574 0 01-.727-1.802h-4zm1.869-4.6a6.572 6.572 0 00-1.869 4.6h4c0-.684.266-1.332.727-1.802l-2.858-2.798zm27.055-27.322l-27.047 27.313 2.842 2.815 27.047-27.314-2.842-2.814zM177.5 156a7.846 7.846 0 00-5.576 2.337l2.842 2.814A3.851 3.851 0 01177.5 160v-4zm5.576 2.337A7.846 7.846 0 00177.5 156v4c1.015 0 1.998.409 2.734 1.151l2.842-2.814zm15.934 6.879c.085.086.14.212.14.352h4a4.505 4.505 0 00-1.281-3.15l-2.859 2.798zm-.284-.124c.098 0 .201.039.284.124l2.859-2.798a4.398 4.398 0 00-3.143-1.326v4zm-4.007 0h4.007v-4h-4.007v4zm-.284.124a.396.396 0 01.284-.124v-4a4.398 4.398 0 00-3.143 1.326l2.859 2.798zm-.14.352c0-.14.055-.266.14-.352l-2.859-2.798a4.505 4.505 0 00-1.281 3.15h4zm0 4.899v-4.899h-4v4.899h4zm8.284 7.542l-8.863-8.949-2.842 2.815 8.863 8.949 2.842-2.815zm-3.429-12.439l.008 13.848 4-.003-.008-13.848-4 .003z"
        ></path>
        <path
          fill={colors.primary[150]}
          fillRule="evenodd"
          d="M271.655 159.744l27.047 27.314c.831.849 1.298 2 1.298 3.201a4.577 4.577 0 01-1.298 3.201 4.38 4.38 0 01-3.133 1.327 4.381 4.381 0 01-3.134-1.327l-1.283-1.31V223h-47.274v-30.866l23.63-24.14-.007-.008-24.936 25.474a4.381 4.381 0 01-3.134 1.327 4.38 4.38 0 01-3.133-1.327 4.577 4.577 0 01-1.298-3.201c0-1.201.467-2.352 1.298-3.201l27.047-27.314A5.847 5.847 0 01267.5 158c1.556 0 3.049.627 4.155 1.744zm19.495 5.824c0-.657-.256-1.286-.71-1.751a2.402 2.402 0 00-1.714-.725h-4.007a2.4 2.4 0 00-1.714.725 2.507 2.507 0 00-.71 1.751v4.899l8.863 8.949-.008-13.848z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[150]}
          d="M298.702 187.058l1.429-1.399-.008-.009-1.421 1.408zm-27.047-27.314l-1.421 1.407 1.421-1.407zm20.78 33.716l1.429-1.399-1.429 1.399zm-1.283-1.31l1.429-1.399a1.999 1.999 0 00-3.429 1.399h2zm0 30.85v2a2 2 0 002-2h-2zm-47.274 0h-2a2 2 0 002 2v-2zm0-30.866l-1.429-1.399a1.998 1.998 0 00-.571 1.399h2zm23.63-24.14l1.429 1.399a2 2 0 000-2.799l-1.429 1.4zm-.007-.008l1.429-1.399a2 2 0 00-2.858 0l1.429 1.399zm-24.936 25.474l-1.429-1.399 1.429 1.399zm-6.267 0l1.429-1.399-1.429 1.399zm0-6.402l-1.421-1.408-.008.009 1.429 1.399zm27.047-27.314l1.421 1.407-1.421-1.407zm27.805 5.824h-2v.002l2-.002zm-8.145-1.751l1.43 1.399-1.43-1.399zm-.71 6.65h-2c0 .527.208 1.033.579 1.408l1.421-1.408zm8.863 8.949l-1.421 1.408a2 2 0 003.421-1.409l-2 .001zm8.965 6.234l-27.047-27.313-2.842 2.814 27.047 27.314 2.842-2.815zm1.877 4.609a6.572 6.572 0 00-1.869-4.6l-2.858 2.798c.461.47.727 1.118.727 1.802h4zm-1.869 4.6a6.572 6.572 0 001.869-4.6h-4c0 .684-.266 1.332-.727 1.802l2.858 2.798zm-4.562 1.928c1.719 0 3.36-.699 4.562-1.928l-2.858-2.798c-.46.47-1.074.726-1.704.726v4zm-4.563-1.928a6.383 6.383 0 004.563 1.928v-4a2.385 2.385 0 01-1.705-.726l-2.858 2.798zm-1.283-1.31l1.283 1.31 2.858-2.798-1.283-1.31-2.858 2.798zm-.571-1.399V223h4v-30.85h-4zm2 28.85h-23.637v4h23.637v-4zm-23.637 0h-23.637v4h23.637v-4zm-21.637 2v-30.866h-4V223h4zm-.571-29.467l23.63-24.14-2.858-2.798-23.63 24.14 2.858 2.798zm20.765-24.148l.007.008 2.858-2.799-.007-.007-2.858 2.798zm-22.078 25.474l24.936-25.474-2.858-2.798-24.936 25.474 2.858 2.798zm-4.563 1.928c1.72 0 3.361-.699 4.563-1.928l-2.858-2.798c-.46.47-1.074.726-1.705.726v4zm-4.562-1.928a6.382 6.382 0 004.562 1.928v-4c-.63 0-1.244-.256-1.704-.726l-2.858 2.798zm-1.869-4.6c0 1.718.667 3.373 1.869 4.6l2.858-2.798a2.574 2.574 0 01-.727-1.802h-4zm1.869-4.6a6.572 6.572 0 00-1.869 4.6h4c0-.684.266-1.332.727-1.802l-2.858-2.798zm27.055-27.322l-27.047 27.313 2.842 2.815 27.047-27.314-2.842-2.814zM267.5 156a7.846 7.846 0 00-5.576 2.337l2.842 2.814A3.851 3.851 0 01267.5 160v-4zm5.576 2.337A7.846 7.846 0 00267.5 156v4c1.015 0 1.998.409 2.734 1.151l2.842-2.814zm15.934 6.879c.085.086.14.212.14.352h4a4.505 4.505 0 00-1.281-3.15l-2.859 2.798zm-.284-.124c.098 0 .201.039.284.124l2.859-2.798a4.398 4.398 0 00-3.143-1.326v4zm-4.007 0h4.007v-4h-4.007v4zm-.284.124a.396.396 0 01.284-.124v-4a4.398 4.398 0 00-3.143 1.326l2.859 2.798zm-.14.352c0-.14.055-.266.14-.352l-2.859-2.798a4.505 4.505 0 00-1.281 3.15h4zm0 4.899v-4.899h-4v4.899h4zm8.284 7.542l-8.863-8.949-2.842 2.815 8.863 8.949 2.842-2.815zm-3.429-12.439l.008 13.848 4-.003-.008-13.848-4 .003z"
        ></path>
        <g filter="url(#filter0_dd_3749_10271)">
          <circle cx="177" cy="65" r="25" fill="#fff"></circle>
          <circle
            cx="177"
            cy="65"
            r="23"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <mask
          id="mask1_3749_10271"
          style={{ maskType: 'alpha' }}
          width="50"
          height="50"
          x="152"
          y="40"
          maskUnits="userSpaceOnUse"
        >
          <circle
            cx="177"
            cy="65"
            r="23"
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </mask>
        <g
          fill={colors.primary[500]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          mask="url(#mask1_3749_10271)"
        >
          <path
            fillRule="evenodd"
            d="M179.398 70.785c2.352.643 3.881 1.53 5.55 3.22 1.438 1.458 2.149 2.66 2.711 4.586.191.654.2.974.233 7.81.033 7.08.032 7.132-.172 7.607-.382.887-1.137 1.378-2.117 1.378-.706 0-1.167-.195-1.648-.697-.634-.66-.614-.431-.614-7.08 0-3.318-.026-6.102-.059-6.186-.034-.09-.173-.154-.33-.154-.158 0-.296.064-.331.154-.032.084-.059 2.826-.059 6.093v5.94l-.729 9.168c-.401 5.042-.773 9.425-.825 9.739-.223 1.34-1.251 2.336-2.687 2.604-.839.156-3.275.058-3.868-.155-.633-.229-1.461-1.005-1.771-1.662-.243-.514-.274-.812-1.027-10.19l-.776-9.66v-5.862c0-3.224-.027-5.93-.059-6.015-.083-.216-.498-.193-.619.034-.067.124-.101 2.238-.101 6.186 0 6.611.019 6.385-.614 7.046-.528.551-.971.722-1.763.681-.588-.03-.758-.082-1.15-.353a2.942 2.942 0 01-.731-.778l-.27-.46-.029-6.571c-.02-4.298.007-6.89.076-7.492.459-3.993 3.715-7.565 8.035-8.817 1.287-.373 1.79-.43 3.407-.39 1.168.03 1.636.084 2.337.276z"
            clipRule="evenodd"
          ></path>
          <rect
            width="7.281"
            height="9.787"
            x="173.113"
            y="56.117"
            rx="3.64"
          ></rect>
        </g>
        <g filter="url(#filter1_dd_3749_10271)">
          <circle cx="268" cy="121" r="25" fill="#fff"></circle>
          <circle
            cx="268"
            cy="121"
            r="23"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <mask
          id="mask2_3749_10271"
          style={{ maskType: 'alpha' }}
          width="50"
          height="50"
          x="243"
          y="96"
          maskUnits="userSpaceOnUse"
        >
          <circle
            cx="268"
            cy="121"
            r="23"
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </mask>
        <g mask="url(#mask2_3749_10271)">
          <path
            fill={colors.primary[100]}
            d="M256.133 126.773c0-5.029 4.536-11.843 9.521-14.281h5.193c4.987 2.442 9.521 9.255 9.521 14.285 0 6.146-5.428 9.09-12.121 9.09-6.692 0-12.114-2.948-12.114-9.094z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M265.156 111.475a1.13 1.13 0 01.498-.116h5.193c.173 0 .344.04.499.116 2.721 1.332 5.24 3.807 7.075 6.561 1.828 2.745 3.08 5.924 3.08 8.741 0 3.462-1.553 6.078-4.043 7.785-2.441 1.674-5.72 2.438-9.211 2.438-3.491 0-6.768-.765-9.208-2.441-2.488-1.708-4.039-4.325-4.039-7.785 0-2.817 1.252-5.997 3.081-8.741 1.835-2.753 4.355-5.228 7.075-6.558zm.767 2.151c-2.186 1.137-4.333 3.228-5.956 5.664-1.685 2.529-2.7 5.271-2.7 7.484 0 2.685 1.159 4.615 3.055 5.917 1.944 1.335 4.724 2.043 7.925 2.043 3.202 0 5.984-.708 7.929-2.042 1.898-1.301 3.059-3.23 3.059-5.915 0-2.213-1.015-4.955-2.7-7.484-1.623-2.436-3.77-4.528-5.957-5.667h-4.655z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[100]}
            d="M268.318 112.488s-1.099-1.186-2.268-2.398a119.326 119.326 0 00-2.453-2.472.863.863 0 01.201-1.385.869.869 0 01.527-.091 27.94 27.94 0 007.987 0 .863.863 0 01.978 1.006.867.867 0 01-.252.474c-.869.846-1.725 1.711-2.453 2.472a184.634 184.634 0 00-2.267 2.394z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M268.319 107.562c1.123 0 2.245-.065 3.361-.195l-3.361.195zm3.361-.195c-.679.672-1.334 1.339-1.911 1.942-.53.548-1.045 1.09-1.45 1.521-.406-.431-.922-.975-1.453-1.526m.621 3.955l-.048-.052-.139-.15-.503-.537c-.419-.446-.982-1.041-1.563-1.642v-.001c-.724-.752-1.572-1.61-2.429-2.447m4.682 4.829a1.136 1.136 0 001.662 0l.049-.052.139-.149.503-.537c.419-.445.982-1.04 1.561-1.64l.003-.003a97.964 97.964 0 012.423-2.442 1.998 1.998 0 00-1.679-3.415l.164 1.121-.162-1.121a26.692 26.692 0 01-3.831.274 26.706 26.706 0 01-3.832-.274 2.002 2.002 0 00-1.682 3.409m2.152-1.063c1.115.13 2.238.195 3.362.195l-3.362-.195zm1.909 1.937a127.803 127.803 0 00-1.909-1.937l1.909 1.937z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M271.868 110.638a8.071 8.071 0 00-.753.56c.289-.064.573-.148.852-.25.574-.267.772-.475.828-.552l-.004-.01-.002-.003c-.097-.007-.374.011-.921.255zm.904-.287zm-5.28 1.359l.252-.266.579-.614 1.081-1.143c.023-.024.047-.047.072-.069.387-.339.798-.65 1.23-.929.044-.028.091-.054.139-.076.846-.392 1.658-.593 2.397-.453.828.157 1.344.697 1.613 1.289.267.589.337 1.329-.082 2.056-.374.65-1.054 1.134-1.9 1.521a8.988 8.988 0 01-3.501.596h-1.056a1.135 1.135 0 01-.824-1.912z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M267.464 111.741a1.134 1.134 0 011.6-.104c.212.187.985.898 1.687 1.942.692 1.03 1.402 2.514 1.275 4.206a1.132 1.132 0 11-2.26-.168c.072-.968-.335-1.938-.897-2.774a8.336 8.336 0 00-1.301-1.503 1.133 1.133 0 01-.104-1.599z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M263.39 108.16c.739-.14 1.551.061 2.397.453.048.022.095.048.139.077.432.279.843.589 1.229.928.025.022.05.045.073.069a475.806 475.806 0 011.66 1.757l.251.266a1.134 1.134 0 01-.824 1.912h-1.055a8.958 8.958 0 01-3.502-.596c-.846-.387-1.525-.871-1.899-1.521-.419-.728-.349-1.467-.082-2.056.269-.592.785-1.132 1.613-1.289zm2.127 3.038a8.206 8.206 0 00-.753-.56c-.547-.244-.824-.262-.921-.255l-.002.003-.004.01c.056.077.254.285.827.552.279.102.564.186.853.25z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M269.169 111.741c.413.47.367 1.186-.104 1.599a8.347 8.347 0 00-1.3 1.503c-.561.835-.969 1.806-.897 2.774a1.132 1.132 0 11-2.26.168c-.126-1.692.583-3.176 1.275-4.206a10.61 10.61 0 011.687-1.942 1.133 1.133 0 011.599.104z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            d="M271.331 129.75h-1.035a4.335 4.335 0 01-2.185-.596 4.383 4.383 0 01-1.593-1.623h2.424a.81.81 0 00.562-.247.825.825 0 000-1.146.805.805 0 00-.562-.247h-2.966a4.038 4.038 0 010-1.076h4.32a.795.795 0 00.588-.233.83.83 0 000-1.174.81.81 0 00-.588-.233h-3.778c.38-.673.93-1.233 1.593-1.622a4.325 4.325 0 012.185-.596h1.035a.811.811 0 00.562-.247.825.825 0 000-1.146.812.812 0 00-.562-.248h-1.035a5.95 5.95 0 00-3.377 1.06 6.04 6.04 0 00-2.195 2.8h-1.374a.798.798 0 00-.588.233.823.823 0 00-.181.906.819.819 0 00.769.501h.992a5.974 5.974 0 00-.027.536c0 .179.011.36.027.538h-.992a.798.798 0 00-.588.233.819.819 0 00-.245.587.833.833 0 00.245.587.81.81 0 00.588.233h1.374a6.04 6.04 0 002.195 2.8 5.95 5.95 0 003.377 1.06h1.035a.812.812 0 00.562-.248.825.825 0 000-1.146.811.811 0 00-.562-.247v.001z"
          ></path>
        </g>
        <g filter="url(#filter2_dd_3749_10271)">
          <circle cx="177" cy="121" r="25" fill="#fff"></circle>
          <circle
            cx="177"
            cy="121"
            r="23"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <mask
          id="mask3_3749_10271"
          style={{ maskType: 'alpha' }}
          width="50"
          height="50"
          x="152"
          y="96"
          maskUnits="userSpaceOnUse"
        >
          <circle
            cx="177"
            cy="121"
            r="23"
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </mask>
        <g mask="url(#mask3_3749_10271)">
          <path
            fill={colors.primary[100]}
            d="M165.133 126.773c0-5.029 4.536-11.843 9.521-14.281h5.193c4.987 2.442 9.521 9.255 9.521 14.285 0 6.146-5.428 9.09-12.121 9.09-6.692 0-12.114-2.948-12.114-9.094z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M174.156 111.475a1.13 1.13 0 01.498-.116h5.193c.173 0 .344.04.499.116 2.721 1.332 5.24 3.807 7.075 6.561 1.828 2.745 3.08 5.924 3.08 8.741 0 3.462-1.553 6.078-4.043 7.785-2.441 1.674-5.72 2.438-9.211 2.438-3.491 0-6.768-.765-9.208-2.441-2.488-1.708-4.039-4.325-4.039-7.785 0-2.817 1.252-5.997 3.081-8.741 1.835-2.753 4.355-5.228 7.075-6.558zm.767 2.151c-2.186 1.137-4.333 3.228-5.956 5.664-1.685 2.529-2.7 5.271-2.7 7.484 0 2.685 1.159 4.615 3.055 5.917 1.944 1.335 4.724 2.043 7.925 2.043 3.202 0 5.984-.708 7.929-2.042 1.898-1.301 3.059-3.23 3.059-5.915 0-2.213-1.015-4.955-2.7-7.484-1.623-2.436-3.77-4.528-5.957-5.667h-4.655z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[100]}
            d="M177.318 112.488s-1.099-1.186-2.268-2.398a119.326 119.326 0 00-2.453-2.472.863.863 0 01.201-1.385.869.869 0 01.527-.091 27.94 27.94 0 007.987 0 .863.863 0 01.978 1.006.867.867 0 01-.252.474c-.869.846-1.725 1.711-2.453 2.472a184.634 184.634 0 00-2.267 2.394z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M177.319 107.562c1.123 0 2.245-.065 3.361-.195l-3.361.195zm3.361-.195c-.679.672-1.334 1.339-1.911 1.942-.53.548-1.045 1.09-1.45 1.521-.406-.431-.922-.975-1.453-1.526m.621 3.955l-.048-.052-.139-.15-.503-.537c-.419-.446-.982-1.041-1.563-1.642v-.001c-.724-.752-1.572-1.61-2.429-2.447m4.682 4.829a1.136 1.136 0 001.662 0l.049-.052.139-.149.503-.537c.419-.445.982-1.04 1.561-1.64l.003-.003a97.964 97.964 0 012.423-2.442 1.998 1.998 0 00-1.679-3.415l.164 1.121-.162-1.121a26.692 26.692 0 01-3.831.274 26.706 26.706 0 01-3.832-.274 2.002 2.002 0 00-1.682 3.409m2.152-1.063c1.115.13 2.238.195 3.362.195l-3.362-.195zm1.909 1.937a127.803 127.803 0 00-1.909-1.937l1.909 1.937z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M180.868 110.638a8.071 8.071 0 00-.753.56c.289-.064.573-.148.852-.25.574-.267.772-.475.828-.552l-.004-.01-.002-.003c-.097-.007-.374.011-.921.255zm.904-.287zm-5.28 1.359l.252-.266.579-.614 1.081-1.143c.023-.024.047-.047.072-.069.387-.339.798-.65 1.23-.929.044-.028.091-.054.139-.076.846-.392 1.658-.593 2.397-.453.828.157 1.344.697 1.613 1.289.267.589.337 1.329-.082 2.056-.374.65-1.054 1.134-1.9 1.521a8.988 8.988 0 01-3.501.596h-1.056a1.135 1.135 0 01-.824-1.912z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M176.464 111.741a1.134 1.134 0 011.6-.104c.212.187.985.898 1.687 1.942.692 1.03 1.402 2.514 1.275 4.206a1.132 1.132 0 11-2.26-.168c.072-.968-.335-1.938-.897-2.774a8.336 8.336 0 00-1.301-1.503 1.133 1.133 0 01-.104-1.599z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M172.39 108.16c.739-.14 1.551.061 2.397.453.048.022.095.048.139.077.432.279.843.589 1.229.928.025.022.05.045.073.069a475.806 475.806 0 011.66 1.757l.251.266a1.134 1.134 0 01-.824 1.912h-1.055a8.958 8.958 0 01-3.502-.596c-.846-.387-1.525-.871-1.899-1.521-.419-.728-.349-1.467-.082-2.056.269-.592.785-1.132 1.613-1.289zm2.127 3.038a8.206 8.206 0 00-.753-.56c-.547-.244-.824-.262-.921-.255l-.002.003-.004.01c.056.077.254.285.827.552.279.102.564.186.853.25z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M178.169 111.741c.413.47.367 1.186-.104 1.599a8.347 8.347 0 00-1.3 1.503c-.561.835-.969 1.806-.897 2.774a1.132 1.132 0 11-2.26.168c-.126-1.692.583-3.176 1.275-4.206a10.61 10.61 0 011.687-1.942 1.133 1.133 0 011.599.104z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            d="M180.331 129.75h-1.035a4.335 4.335 0 01-2.185-.596 4.383 4.383 0 01-1.593-1.623h2.424a.81.81 0 00.562-.247.825.825 0 000-1.146.805.805 0 00-.562-.247h-2.966a4.038 4.038 0 010-1.076h4.32a.795.795 0 00.588-.233.83.83 0 000-1.174.81.81 0 00-.588-.233h-3.778c.38-.673.93-1.233 1.593-1.622a4.325 4.325 0 012.185-.596h1.035a.811.811 0 00.562-.247.825.825 0 000-1.146.812.812 0 00-.562-.248h-1.035a5.95 5.95 0 00-3.377 1.06 6.04 6.04 0 00-2.195 2.8h-1.374a.798.798 0 00-.588.233.823.823 0 00-.181.906.819.819 0 00.769.501h.992a5.974 5.974 0 00-.027.536c0 .179.011.36.027.538h-.992a.798.798 0 00-.588.233.819.819 0 00-.245.587.833.833 0 00.245.587.81.81 0 00.588.233h1.374a6.04 6.04 0 002.195 2.8 5.95 5.95 0 003.377 1.06h1.035a.812.812 0 00.562-.248.825.825 0 000-1.146.811.811 0 00-.562-.247v.001z"
          ></path>
        </g>
        <g filter="url(#filter3_dd_3749_10271)">
          <circle cx="86" cy="121" r="25" fill="#fff"></circle>
          <circle
            cx="86"
            cy="121"
            r="23"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <mask
          id="mask4_3749_10271"
          style={{ maskType: 'alpha' }}
          width="50"
          height="50"
          x="61"
          y="96"
          maskUnits="userSpaceOnUse"
        >
          <circle
            cx="86"
            cy="121"
            r="23"
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </mask>
        <g mask="url(#mask4_3749_10271)">
          <path
            fill={colors.primary[100]}
            d="M74.133 126.773c0-5.029 4.536-11.843 9.52-14.281h5.194c4.987 2.442 9.521 9.255 9.521 14.285 0 6.146-5.428 9.09-12.12 9.09-6.694 0-12.115-2.948-12.115-9.094z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M83.156 111.475c.155-.076.325-.116.498-.116h5.194c.172 0 .343.04.498.116 2.72 1.332 5.24 3.807 7.075 6.561 1.828 2.745 3.08 5.924 3.08 8.741 0 3.462-1.553 6.078-4.043 7.785-2.441 1.674-5.72 2.438-9.21 2.438-3.492 0-6.769-.765-9.209-2.441-2.488-1.708-4.039-4.325-4.039-7.785 0-2.817 1.252-5.997 3.081-8.741 1.835-2.753 4.355-5.228 7.075-6.558zm.767 2.151c-2.186 1.137-4.333 3.228-5.956 5.664-1.685 2.529-2.7 5.271-2.7 7.484 0 2.685 1.159 4.615 3.055 5.917 1.944 1.335 4.724 2.043 7.925 2.043 3.202 0 5.984-.708 7.93-2.042 1.897-1.301 3.058-3.23 3.058-5.915 0-2.213-1.015-4.955-2.7-7.484-1.623-2.436-3.77-4.528-5.957-5.667h-4.654z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[100]}
            d="M86.319 112.488s-1.1-1.186-2.269-2.398a118.875 118.875 0 00-2.453-2.472.863.863 0 01.201-1.385.867.867 0 01.527-.091 27.935 27.935 0 007.987 0 .865.865 0 01.726 1.48 99.49 99.49 0 00-2.453 2.472 182.258 182.258 0 00-2.266 2.394z"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M86.319 107.562c1.123 0 2.245-.065 3.36-.195l-3.36.195zm3.36-.195c-.678.672-1.334 1.339-1.91 1.942-.53.548-1.044 1.09-1.45 1.521-.406-.431-.922-.975-1.453-1.526m.621 3.955l-.048-.052-.14-.15-.502-.537a172.68 172.68 0 00-1.563-1.642v-.001c-.724-.752-1.572-1.61-2.429-2.447m4.682 4.829a1.135 1.135 0 001.663 0l.048-.052.14-.149.502-.537c.419-.445.982-1.04 1.56-1.64l.004-.003a98.498 98.498 0 012.423-2.442 2.001 2.001 0 00-.459-3.206 2.002 2.002 0 00-1.22-.209l.164 1.121-.162-1.121c-1.27.183-2.55.275-3.831.274a26.697 26.697 0 01-3.832-.274 2 2 0 00-1.682 3.409m2.152-1.063c1.116.13 2.238.195 3.362.195l-3.362-.195zm1.909 1.937a125.886 125.886 0 00-1.91-1.937l1.91 1.937z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M89.868 110.638a8.13 8.13 0 00-.753.56c.289-.064.573-.148.852-.25.574-.267.772-.475.828-.552l-.004-.01-.002-.003c-.097-.007-.374.011-.921.255zm.904-.287zm-5.28 1.359l.252-.266.579-.614 1.081-1.143c.023-.024.047-.047.072-.069.387-.339.798-.65 1.23-.929a1.2 1.2 0 01.138-.076c.847-.392 1.659-.593 2.398-.453.828.157 1.344.697 1.612 1.289.268.589.338 1.329-.08 2.056-.375.65-1.055 1.134-1.9 1.521a8.987 8.987 0 01-3.502.596h-1.056a1.134 1.134 0 01-.824-1.912z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M85.464 111.741a1.134 1.134 0 011.6-.104c.212.187.985.898 1.687 1.942.692 1.03 1.402 2.514 1.275 4.206a1.133 1.133 0 11-2.26-.168c.072-.968-.335-1.938-.897-2.774a8.343 8.343 0 00-1.3-1.503 1.133 1.133 0 01-.105-1.599z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M81.39 108.16c.739-.14 1.55.061 2.397.453.048.022.095.048.14.077.431.279.842.589 1.228.928.025.022.05.045.073.069a451.715 451.715 0 011.66 1.757l.251.266a1.134 1.134 0 01-.824 1.912H85.26a8.952 8.952 0 01-3.502-.596c-.846-.387-1.525-.871-1.9-1.521-.418-.728-.348-1.467-.08-2.056.268-.592.784-1.132 1.612-1.289zm2.127 3.038a8.162 8.162 0 00-.753-.56c-.547-.244-.824-.262-.921-.255a.044.044 0 01-.002.003l-.004.01c.056.077.254.285.827.552.28.102.564.186.853.25z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            fillRule="evenodd"
            d="M87.17 111.741c.412.47.366 1.186-.105 1.599a8.345 8.345 0 00-1.3 1.503c-.561.835-.969 1.806-.897 2.774a1.133 1.133 0 11-2.26.168c-.126-1.692.583-3.176 1.275-4.206a10.577 10.577 0 011.687-1.942 1.134 1.134 0 011.6.104z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            d="M89.33 129.75h-1.034a4.332 4.332 0 01-2.185-.596 4.382 4.382 0 01-1.593-1.623h2.424a.81.81 0 00.562-.247.824.824 0 000-1.146.805.805 0 00-.562-.247h-2.966a4.021 4.021 0 010-1.076h4.32a.8.8 0 00.588-.233.814.814 0 00.245-.587.823.823 0 00-.516-.764.8.8 0 00-.317-.056h-3.778c.38-.673.93-1.233 1.593-1.622a4.322 4.322 0 012.185-.596h1.035a.81.81 0 00.562-.247.824.824 0 00-.562-1.394h-1.035a5.953 5.953 0 00-3.377 1.06 6.035 6.035 0 00-2.195 2.8H81.35a.8.8 0 00-.588.233.816.816 0 00-.245.587.828.828 0 00.245.587.805.805 0 00.588.233h.992a6.205 6.205 0 00-.027.536c0 .179.011.36.027.538h-.992a.8.8 0 00-.588.233.812.812 0 00-.245.587.831.831 0 00.245.587.805.805 0 00.588.233h1.374a6.036 6.036 0 002.195 2.8 5.953 5.953 0 003.377 1.06h1.035a.81.81 0 00.562-.248.824.824 0 000-1.146.81.81 0 00-.562-.247v.001z"
          ></path>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_3749_10271"
          width="82"
          height="82"
          x="136"
          y="32"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3749_10271"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_3749_10271"
            result="effect2_dropShadow_3749_10271"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_3749_10271"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_dd_3749_10271"
          width="82"
          height="82"
          x="227"
          y="88"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3749_10271"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_3749_10271"
            result="effect2_dropShadow_3749_10271"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_3749_10271"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter2_dd_3749_10271"
          width="82"
          height="82"
          x="136"
          y="88"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3749_10271"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_3749_10271"
            result="effect2_dropShadow_3749_10271"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_3749_10271"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter3_dd_3749_10271"
          width="82"
          height="82"
          x="45"
          y="88"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3749_10271"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_3749_10271"
            result="effect2_dropShadow_3749_10271"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_3749_10271"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationRentalProperties;
